module.exports = __webpack_public_path__ + "img/project1_medium.1e699109.jpg";